import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { domainLogoWhite, domainLogoAlt } from '../domain-logo';
import { ROUTE_PATH } from '../../routes/route-paths';
import { useMediaQuery } from '../../hooks/utils/useMediaQuery';
import { useAppSettings } from '../../hooks/api/useAppSettings';
import { Features, useFeatureFlag } from '../../hooks/api/useFeatureFlag';
import { useUser } from '../../hooks/api/useUser';

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const history = useHistory();
  const dfMdMedia = useMediaQuery('md');
  const { data: appSettings } = useAppSettings();
  const { data: user } = useUser();
  const clientId = user?.client_id;
  const poweredByHeaderEnabled = !!user?.caller_role?.active_subscription?.package?.client?.powered_by_header_enabled;
  const footerDisclaimerFlag = useFeatureFlag(Features.FOOTER_DISCLAIMER);
  const flag = footerDisclaimerFlag.data?.data[Features.FOOTER_DISCLAIMER];

  const footerDisclaimerEnabled =
    !!footerDisclaimerFlag.enabled &&
    (!flag?.client_ids?.length || (clientId != null && flag.client_ids.includes(clientId)));
  const footerDisclaimerText = appSettings?.FOOTER_DISCLAIMER_TEXT;
  const handleFAQClick = useCallback(() => {
    history.push(ROUTE_PATH.FAQS);
  }, [history]);

  const handleSupportClick = useCallback(() => {
    history.push(ROUTE_PATH.SUPPORT);
  }, [history]);

  return (
    <footer className={`bg-footer-bg flex w-full items-center justify-center py-12 ${className}`}>
      <div className="max-w-page mx-auto w-full px-6">
        <div className={`flex w-full justify-between ${dfMdMedia ? 'flex-row items-center' : 'flex-col items-start'}`}>
          {/* Left Side - Links */}
          <div className="flex flex-col items-start gap-0">
            <button
              onClick={handleFAQClick}
              className="flex h-[52px] items-end text-left font-['Manrope'] text-lg font-semibold leading-7 text-white transition-opacity hover:opacity-80"
            >
              FAQ
            </button>
            <button
              onClick={handleSupportClick}
              className="flex h-[41px] items-end text-left font-['Manrope'] text-lg font-semibold leading-7 text-white transition-opacity hover:opacity-80"
            >
              Support
            </button>
          </div>

          {/* Right Side - Logo */}
          <div className={`${dfMdMedia ? 'mt-0 items-end' : 'mt-10 items-start'} flex flex-col justify-center gap-3`}>
            {poweredByHeaderEnabled ? (
              <span className="text-md font-['Manrope'] font-thin leading-4 text-white/80">Powered by</span>
            ) : null}
            <img src={domainLogoWhite} alt={domainLogoAlt} className="h-8 w-auto" />
          </div>
        </div>

        {footerDisclaimerEnabled && footerDisclaimerText ? (
          <div className="mt-10 border-t border-white/20 pt-6">
            <div
              className="font-['Manrope'] text-sm font-normal leading-5 text-white/90"
              dangerouslySetInnerHTML={{ __html: footerDisclaimerText }}
            />
          </div>
        ) : null}
      </div>
    </footer>
  );
};
